import { render, staticRenderFns } from "./PostsTabWrapper.vue?vue&type=template&id=5bb9d0a3&"
import script from "./PostsTabWrapper.vue?vue&type=script&lang=js&"
export * from "./PostsTabWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports